export const GET_DASHBOARD_REQUEST = 'GET_DASHBOARD_REQUEST';
export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS';
export const GET_DASHBOARD_ERROR = 'GET_DASHBOARD_ERROR';

export const GET_DASHBOARD_MACHINES_REQUEST = 'GET_DASHBOARD_MACHINES_REQUEST';
export const GET_DASHBOARD_MACHINES_SUCCESS = 'GET_DASHBOARD_MACHINES_SUCCESS';
export const GET_DASHBOARD_MACHINES_ERROR = 'GET_DASHBOARD_MACHINES_ERROR';
